/**
 * Meta Pixel — safe wrapper around window.fbq.
 *
 * Funnel events fired in order:
 *   PageView          — every route change (RouteTracker in App.js)
 *   CompleteRegistration — first-time sign-up detected via Clerk createdAt
 *   ViewContent       — /gopro page load (content_name: 'GoPro')
 *   Search            — user clicks "Search Jobs"
 *   InitiateCheckout  — user clicks "Upgrade to Pro" (fires before Stripe redirect)
 *   Purchase          — user returns from Stripe with ?success=true and isPremium confirmed
 */

export function fbTrack(event, params) {
  if (typeof window.fbq === 'function') {
    window.fbq('track', event, params);
  }
}
